// extracted by mini-css-extract-plugin
export default {"container":"FlowStatQuery_container__jHt2A","title":"FlowStatQuery_title__XEv7G","refresh":"FlowStatQuery_refresh__p8gXc"};